import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'CustomFieldsDisplayField',
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [String, Number, Boolean],
      required: false,
      default: ''
    },
    type: {
      type: String,
      required: false,
      default: ''
    },
    showLastDigitOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    iconColor: {
      type: String,
      required: false,
      default: null
    },
    iconType: {
      type: String,
      required: false,
      default: 'fal'
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    itemImage: {
      type: String,
      required: false,
      default: ''
    },
    copy: {
      type: Boolean,
      required: false,
      default: false
    },
    redirect: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['image', 'color', 'UiTheme'])), {}, {
    getValue: function getValue() {
      if (this.showLastDigitOnly) {
        var count = 4;
        return new Array(this.value.length - count + 1).join('*') + this.value.slice(-count);
      } else {
        return this.value;
      }
    }
  }),
  methods: {
    copyToClipboard: function copyToClipboard(event, data) {
      var value = '';

      if (_typeof(data) === 'object' && data !== null) {
        value = JSON.stringify(data);
      } else if (typeof data === 'string') {
        value = data;
      }

      event.stopPropagation(); // create textarea to copy from

      var copyElement = document.createElement('textarea');
      copyElement.value = value; // set styles to hide textarea from viewport

      copyElement.style.position = 'absolute';
      copyElement.style.top = '-99999px'; // add to element to body otherwise we can't select/copy

      document.body.appendChild(copyElement); // copy text

      copyElement.select();
      document.execCommand('copy'); // remove element

      copyElement.remove();
    }
  }
};